<template>
  <div
    class="ah-filter-badge"
    :class="{ active: isActive }"
    @click="handleClick"
  >
    <div class="ah-filter-badge-label">
      {{ filter.name }}
    </div>
  </div>
</template>

<script>
  import { mutations } from '../../data/store'

  export default {
    name: 'filter-badge',
    props: {
      filter: Object,
    },
    computed: {
      isActive: function() {
        return this.filter.active
      },
    },
    methods: {
      handleClick: function() {
        mutations.toggleFilter(this.filter)
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../../scss/_variablesAH.scss";

  .ah-filter-badge {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f6f6f8;
    margin: 4px;
    padding: 12px 15px;
    border-radius: 22px;
    cursor: pointer;
    &:hover {
      background-color: darken(#f6f6f8, 5%);
    }
    &.active {
      background-color: $ah-blue;
      .ah-filter-badge-label {
        color: white;
      }
      &:hover {
        background-color: lighten($ah-blue, 5%);
      }
    }
  }
  .ah-filter-badge-label {
    font-family: $font-main;
    font-size: 16px;
    color: $ah-blue;
    line-height: 20px;
    font-weight: normal;
    cursor: pointer;
  }
</style>